import { render, staticRenderFns } from "./TotalMonth.vue?vue&type=template&id=0bdb16b8&"
import script from "./TotalMonth.vue?vue&type=script&lang=js&"
export * from "./TotalMonth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports